import { Colors } from "@auteco/theme";
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(() => ({
    editBtnsContainer: {
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        position: 'relative'
    },
    formControl: {
        width: '120px',
        marginRight: '20px'
    },
    label: {
        marginLeft: '8px'
    },
    acceptBtn: {
        width: '80px'
    },
    cancelBtn: {
        width: '80px',
        border: `2px solid ${Colors.DARK_BLUE}`,
        background: '#fff',
        color: Colors.DARK_BLUE,
        marginRight: '12px',
        '&:hover': {
            background: 'white',
            color: Colors.DARK_BLUE
        }
    },
    actionBtn: {
        width: '40px',
        color: 'black'
    },
    iconBtn: {
        fontSize: '20px'
    }
}))

export { useStyles }